// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from "firebase/app";
import "firebase/auth";

export const auth = firebase.initializeApp({
        apiKey: "AIzaSyDWR_j8nruZTd9xaFwkOj233UD-TwOZqmQ",
        authDomain: "unichat-53e64.firebaseapp.com",
        projectId: "unichat-53e64",
        storageBucket: "unichat-53e64.appspot.com",
        messagingSenderId: "537359106342",
        appId: "1:537359106342:web:f8c3bce647af8a7e7501e7",
        measurementId: "G-WDFSQJJ1SQ"
  }).auth();
